import {
  asAnnotationStatuses,
  getAvailableFilters,
} from '../../../containers/AnnotationList/helpers';
import { FilterableAnnotationOptions } from '../../../containers/AnnotationList/types';
import { QueryT } from './types';

export const isRangeFilter = (param: string) =>
  param.match(/([a-zA-Z_]*)(_before|_after)$/);

type ParsedQueryT = Omit<QueryT, 'page' | 'pageSize' | 'status'> & {
  page?: number;
  pageSize?: number;
  status?: string | string[];
};

export const removeNonActiveRanges = (query: ParsedQueryT) => {
  const { status, ..._query } = query;

  if (!status || !status.length) return query;

  const availableDateFilters = getAvailableFilters(
    asAnnotationStatuses(status)
  );

  const availableQuery = (
    Object.keys(_query) as (keyof Omit<QueryT, 'status'>)[]
  ).reduce((acc, param) => {
    const rangeFilter = isRangeFilter(param);

    if (rangeFilter && rangeFilter[1]) {
      if (
        availableDateFilters.includes(
          rangeFilter[1] as FilterableAnnotationOptions
        )
      ) {
        return { ...acc, [param]: _query[param] };
      }

      return acc;
    }
    return { ...acc, [param]: _query[param] };
  }, {});

  return { ...availableQuery, status };
};
